import type { SensorDescriptor, SensorOptions } from '@dnd-kit/core';
import { MouseSensor, TouchSensor, useSensors as useSens, useSensor } from '@dnd-kit/core';
import isEqual from 'lodash/isEqual';
import { useRef } from 'react';

export const useSensors = (touchDelay?: number): Array<SensorDescriptor<SensorOptions>> => {
    const sensors = useSens(
        useSensor(MouseSensor, {
            activationConstraint: {
                delay: 0,
                tolerance: 0,
            },
        }),
        useSensor(TouchSensor, {
            activationConstraint: {
                delay: touchDelay || 0,
                tolerance: 0,
            },
        }),
    );
    const prev = useRef(sensors);

    if (isEqual(prev.current, sensors)) {
        return prev.current;
    }

    prev.current = sensors;
    return sensors;
};
